import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './ZonePreview.styles';
import { ZoneValidations } from '../../../../models';
import {
  LOCATION_TYPES,
  GEO_REFERENCE_TYPES
} from '../../../../constants/areas';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import MapGLInput from '../../../inputs/mapglinput/MapGLInput';

import {  editAreaLoadAction } from '../../../../reducers/actions';;


function convertPolygons(area, zones){
  let z = [];
  if(zones){
    z = zones.map((z)=>{return {type:'zone', name: z.name, polygon: z.polygon}});
  }
  let p =  {
    current: {},
    polygons: z
  }
  return p;
}


export class ZonePreview extends Component {
  componentDidMount(){
    if(this.props && this.props.area){
      this.props.editAreaLoad(this.props.area.id);
    }
  }
  render() {
    if (!this.props.area) {
      return false;
    }
    let { nwCorner, seCorner } = this.props.area.indoorMapping;
    let file =
      this.props.area.file &&
      !!this.props.area.file.length &&
      this.props.area.file[0].preview;
    let showMap =
      this.props.area.location === LOCATION_TYPES.OUTDOOR ||
      this.props.area.geoReferenced === GEO_REFERENCE_TYPES.YES;

    let polygons = convertPolygons(this.props.area, this.props.zones);
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        <Translate className={css(styles.title)} value="add.zone.drawing" />
        <Field
          name="polygon"
          type="polygon"
          showMap={showMap}
          validate={ZoneValidations.polygon}
          component={MapGLInput}
          props={{
            nwCorner,
            seCorner,
            file,
            areaPolygon: this.props.area.polygon,
            polygons: polygons,
            options: {
              ...(showMap
                ? {}
                : {
                    zoom: 12,
                    minZoom: 10,
                    maxZoom: 14
                  })
            }
          }}
        />
        <FormActions>
          <Button>
            <Translate value="add.add" />
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editAreaLoad() {
      dispatch(editAreaLoadAction(...arguments));
    }
  }
}

const selector = formValueSelector('addzone');
const mapStateToProps = state => {
  return { ...selector(state, 'site', 'area'), zones: state.areas.editAreaZones };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'addzone',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(ZonePreview)
);



// WEBPACK FOOTER //
// ./src/components/forms/addzoneform/zonepreview/ZonePreview.js